// How long the builder takes to show the mic, counting only time the tab was actually on screen.
// Phones pause 3D drawing in a tab that's in the background, so a tab opened and left behind another
// one finishes loading only when it's looked at again, and the plain timer reports minutes of "loading".
// Started as early as the app code runs; Chrome also reports visibility changes from before that.
let hiddenMs = 0
let hiddenSince = null
let wasHidden = false

try {
  if (typeof PerformanceObserver !== 'undefined' && (PerformanceObserver.supportedEntryTypes || []).includes('visibility-state')) {
    // Chrome: the full history since the page opened
    const entries = performance.getEntriesByType('visibility-state')
    entries.forEach((e) => {
      if (e.name === 'hidden') {
        wasHidden = true
        if (hiddenSince === null) hiddenSince = e.startTime
      } else if (hiddenSince !== null) {
        hiddenMs += e.startTime - hiddenSince
        hiddenSince = null
      }
    })
  }
  if (document.visibilityState === 'hidden') {
    wasHidden = true
    if (hiddenSince === null) hiddenSince = performance.now()
  }
  document.addEventListener('visibilitychange', () => {
    const now = performance.now()
    if (document.visibilityState === 'hidden') {
      wasHidden = true
      if (hiddenSince === null) hiddenSince = now
    } else if (hiddenSince !== null) {
      hiddenMs += now - hiddenSince
      hiddenSince = null
    }
  })
} catch (e) {}

export function loadTimingProps() {
  const now = performance.now()
  const hidden = hiddenMs + (hiddenSince !== null ? now - hiddenSince : 0)
  const r = (ms) => Math.round(ms / 100) / 10
  return { load_seconds: r(now), visible_seconds: r(Math.max(0, now - hidden)), hidden_during_load: wasHidden }
}
